import { UserType } from "@core/enums/user-type";
import { TPagination } from "@custom-types/sorting";

import { CompanyUserModel } from "./user-company.model";
import { UserExtended } from "./user-extended.model";

export type TAllClientsPaginated = TPagination & {
  data: Array<TAllClients>;
};

export type TAllClients = UserExtended & CompanyUserModel;

export interface UserModel {
  email: string;
  id: string;
  rights: Array<number>;
  userName: string;
  userType: UserType;
}

export class User implements UserModel {
  email = "";
  id = "";
  rights: Array<number> = [];
  userName = "";
  userType = UserType.private;

  constructor(dto?: User) {
    if (!dto) {
      return;
    }
    this.email = dto.email;
    this.id = dto.id;
    this.rights = dto.rights;
    this.userName = dto.userName;
  }

  static jsonSerialize(user: User): UserModel {
    return { ...user };
  }

  static parseDto(dto: UserModel): User {
    return new User({ ...dto });
  }
}
